import farm_manager from 'src/Resources/Images/productImages/farmmanager.png'
import farm_manager_simplified from 'src/Resources/Images/productImages/farmmanager_simplified.png'
import hager_default from 'src/Resources/Images/productImages/hager_default.png'
import hager_default_simplified from 'src/Resources/Images/productImages/hager_default_simplified.png'
import qntm_simplified from 'src/Resources/Images/productImages/qntm-simplified.png'
import qntm from 'src/Resources/Images/productImages/qntm.png'
import quattroporte from 'src/Resources/Images/productImages/quattroporte.png'
import quattroporte_simplified from 'src/Resources/Images/productImages/quattroporte_simplified.png'
import s10_x_s10_x_compact_simplified from 'src/Resources/Images/productImages/s10_ x_s10_x_compact_simplified.png'
import s10_e from 'src/Resources/Images/productImages/s10_e.png'
import s10_e_compact from 'src/Resources/Images/productImages/s10_e_compact.png'
import s10_e_compact_simplified from 'src/Resources/Images/productImages/s10_e_compact_simplified.png'
import s10_e_pro from 'src/Resources/Images/productImages/s10_e_pro.png'
import s10_e_pro_compact from 'src/Resources/Images/productImages/s10_e_pro_compact.png'
import s10_e_pro_compact_simplified from 'src/Resources/Images/productImages/s10_e_pro_compact_simplified.png'
import s10_e_pro_simplified from 'src/Resources/Images/productImages/s10_e_pro_simplified.png'
import s10_e_simplified from 'src/Resources/Images/productImages/s10_e_simplified.png'
import s10_mini from 'src/Resources/Images/productImages/s10_mini.png'
import s10_mini_simplified from 'src/Resources/Images/productImages/s10_mini_simplified.png'
import s10_se from 'src/Resources/Images/productImages/s10_se.png'
import s10_se_simplified from 'src/Resources/Images/productImages/s10_se_simplified.png'
import s10_sp40_simplified from 'src/Resources/Images/productImages/s10_sp40_simplified.png'
import s10_x from 'src/Resources/Images/productImages/s10_x.png'
import s10_x_pro from 'src/Resources/Images/productImages/s10_x_pro.png'
import s10_x_pro_simplified from 'src/Resources/Images/productImages/s10_x_pro_simplified.png'
import s10_x_s10_x_compact from 'src/Resources/Images/productImages/s10_x_s10_x_compact.png'
import s10_x_simplified from 'src/Resources/Images/productImages/s10_x_simplified.png'
import the_one from 'src/Resources/Images/productImages/the_one.png'
import the_one_simplified from 'src/Resources/Images/productImages/the_one_simplified.png'
import xem1200_flow from 'src/Resources/Images/productImages/xem1200_flow.png'
import xem1200_flow_simplified from 'src/Resources/Images/productImages/xem1200_flow_simplified.png'
import { EmsProductType, EmsProductTypeValue } from 'src/Routes/Installation/InstallationModel'
import { ImageVersion, ImageVersions } from '../types'
import { isFlowTheme } from 'src/Libs/utils/theme-helpers'
import { InstallationStatus } from 'src/Libs/installation-status/types'

type ProductImageMap = Record<'fallbackHager' | Lowercase<EmsProductTypeValue>, string>

/**
 * 3D Product Images
 */
const productImageMap3D = {
  [EmsProductType.s10_e.toLowerCase()]: s10_e,
  [EmsProductType.s10_se.toLowerCase()]: s10_se,
  [EmsProductType.s10_e_compact.toLowerCase()]: s10_e_compact,
  [EmsProductType.s10_x_compact.toLowerCase()]: s10_e_compact,
  [EmsProductType.s10_e_pro.toLowerCase()]: s10_e_pro,
  /* TODO: this should be changed when a good image for s10_sp40 is provided */
  [EmsProductType.s10_sp40.toLowerCase()]: s10_e,
  [EmsProductType.s10_x_pro.toLowerCase()]: s10_x_pro,
  /* TODO: update when s20 image is provided */
  [EmsProductType.s20_x_pro.toLowerCase()]: s10_x_pro,
  [EmsProductType.s10_mini.toLowerCase()]: s10_mini,
  [EmsProductType.s10_x.toLowerCase()]: s10_x,
  [EmsProductType.s10_e_pro_compact.toLowerCase()]: s10_e_pro_compact,
  [EmsProductType.quattroporte.toLowerCase()]: quattroporte,
  [EmsProductType.s10_x_S10_x_compact.toLowerCase()]: s10_x_s10_x_compact,
  [EmsProductType.farm_manager.toLowerCase()]: farm_manager,
  [EmsProductType.s10_xplus.toLowerCase()]: s10_x_s10_x_compact,
  [EmsProductType.s10_xflex.toLowerCase()]: s10_x_pro,
  [EmsProductType.one.toLowerCase()]: the_one,
  [EmsProductType.xem1200.toLowerCase()]: xem1200_flow,
  [EmsProductType.qntm.toLowerCase()]: qntm,
  fallbackHager: hager_default,
} as ProductImageMap

/**
 * Simplified 2D Product Images.
 * For example useful if the displayed image is small.
 */
const productImageMap2D = {
  [EmsProductType.s10_e.toLowerCase()]: s10_e_simplified,
  [EmsProductType.s10_se.toLowerCase()]: s10_se_simplified,
  [EmsProductType.s10_e_compact.toLowerCase()]: s10_e_compact_simplified,
  [EmsProductType.s10_x_compact.toLowerCase()]: s10_e_compact_simplified,
  [EmsProductType.s10_e_pro.toLowerCase()]: s10_e_pro_simplified,
  [EmsProductType.s10_sp40.toLowerCase()]: s10_sp40_simplified,
  [EmsProductType.s10_x_pro.toLowerCase()]: s10_x_pro_simplified,
  /* TODO: update when s20 image is provided */
  [EmsProductType.s20_x_pro.toLowerCase()]: s10_x_pro_simplified,
  [EmsProductType.s10_mini.toLowerCase()]: s10_mini_simplified,
  [EmsProductType.s10_x.toLowerCase()]: s10_x_simplified,
  [EmsProductType.s10_e_pro_compact.toLowerCase()]: s10_e_pro_compact_simplified,
  [EmsProductType.quattroporte.toLowerCase()]: quattroporte_simplified,
  [EmsProductType.s10_x_S10_x_compact.toLowerCase()]: s10_x_s10_x_compact_simplified,
  [EmsProductType.farm_manager.toLowerCase()]: farm_manager_simplified,
  [EmsProductType.s10_xplus.toLowerCase()]: s10_x_s10_x_compact_simplified,
  [EmsProductType.s10_xflex.toLowerCase()]: s10_x_pro_simplified,
  [EmsProductType.one.toLowerCase()]: the_one_simplified,
  [EmsProductType.xem1200.toLowerCase()]: xem1200_flow_simplified,
  [EmsProductType.qntm.toLowerCase()]: qntm_simplified,
  fallbackHager: hager_default_simplified,
} as ProductImageMap

const DEFAULT_2D_PRODUCT_ICON = isFlowTheme ? productImageMap2D['fallbackHager'] : s10_e_simplified
const DEFAULT_3D_PRODUCT_ICON = isFlowTheme ? productImageMap3D['fallbackHager'] : s10_e

export const getEmsProductImage = (
  emsMasterProduct: EmsProductTypeValue | undefined,
  installationStatus?: InstallationStatus,
  version: ImageVersion = ImageVersions.TwoDimensional
): string => {
  if (!emsMasterProduct) {
    if (installationStatus === 'planned') {
      return version === ImageVersions.TwoDimensional ? productImageMap2D['qntm'] : productImageMap3D['qntm']
    }
    return version === ImageVersions.TwoDimensional ? DEFAULT_2D_PRODUCT_ICON : DEFAULT_3D_PRODUCT_ICON
  }
  const productKey = emsMasterProduct.toLowerCase() as Lowercase<EmsProductTypeValue>
  if (version === ImageVersions.ThreeDimensional) return productImageMap3D[productKey] || productImageMap3D['fallbackHager']
  return productImageMap2D[productKey] || productImageMap2D['fallbackHager']
}
